export const PREVIEW_ITEMS_QUANTITY = 6;
export const TREATMENTS_OPTION = 'treatments';
export const SPA_CLASSES_OPTION = 'classes';
export const SPA_DAYS_OPTION = 'spadays';
export const FACILITIES_OPTION = 'facilities';
export const SPA_STAYS_OPTION = 'spastays';
